import { combineReducers } from "redux";
import authReducer from "./AuthReducer";
// import companyReducer from "./CompanyReducer";

const combinedReducer = combineReducers({
  authReducer,
//   companyReducer,
});

export default combinedReducer;